<template>
  <div class="element-type" :class="{ selected: isSelected }" @click="selectType">
    <div class="element-type-name">
      <div>
        {{ title }}
        <span>{{ nrOfElements }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: '',
    },
    nrOfElements: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: '',
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },
  emitsOptions: ['set-selected-type'],
  setup(props, { emit }) {
    const selectType = () => emit('set-selected-type', props.id);

    return {
      selectType,
    };
  },
};
</script>

<style scoped lang="scss">
.element-type:hover {
  background-color: $bb-neutral-4;
}

.selected {
  background-color: $bb-neutral-4;
}

.element-type {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  transition: background-color 0.3s ease;
  cursor: pointer;
  padding: 0 $bb-spacing-3;
  height: 44px;
  border-radius: 12px;

  &:hover {
    background-color: $bb-neutral-6;
  }

  .element-type-name {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    span {
      color: $bb-neutral-2;
    }

    @include bb-medium-text-styles('md');
    line-height: $bb-spacing-5;
    color: $bb-neutral-1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
  }
}
</style>
